// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FileUploadWrapper_wrapper__1fNi4","hover":"FileUploadWrapper_hover__13BGu","fileInput":"FileUploadWrapper_fileInput__3iTy6"};